const GTM_ID = 'GTM-K9XQ232T';

type DataLayer = unknown[];

export function loadGtm(): void {
  if (process.env.APP_ENV !== 'production') return;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  // Idempotency guard — prevent duplicate tags on multiple calls
  if (document.querySelector(`script[src*="${GTM_ID}"]`)) return;

  const w = window as Window & { dataLayer?: DataLayer };
  const dataLayer: DataLayer = Array.isArray(w.dataLayer) ? w.dataLayer : [];
  w.dataLayer = dataLayer;
  dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);
}
